import { Component, Input, OnInit } from '@angular/core';
import { IReporteVehiculos, vehiculosText } from 'src/app/models/vehiculos/vehiculos.model';

export interface InformacionBasicaElement {
  name: string;
  value: any;
}

export interface TableVehiculosElement {
  ppu: string;
  marca: string;
  modelo: string;
  color: string;
  tipo_vehiculo: string;
  anio_fabricacion: string;
  ultima_transferencia: string;
  numero_motor: string;
  numero_chasis: string;
  tasacion: string;
}

@Component({
  selector: 'app-vehiculos-viewer',
  templateUrl: './vehiculos-viewer.component.html',
  styleUrls: ['./vehiculos-viewer.component.scss']
})
export class VehiculosViewerComponent implements OnInit {
  @Input() content: IReporteVehiculos | any;
  @Input() showHeader: boolean = true;
  @Input() fromConsolidado: boolean = false;
  public header: string[] = [
    'ppu',
    'marca',
    'modelo',
    'color',
    'tipo_vehiculo',
    'anio_fabricacion',
    'ultima_transferencia',
    'numero_motor',
    'numero_chasis',
    'tasacion'
  ];
  public vehiculosText: any = vehiculosText;
  public datosBasicos: InformacionBasicaElement[] = [];
  public tableVehiculos: TableVehiculosElement[] = [];
  displayedColumns: string[] = ['name', 'value'];
  displayedColumnsVehiculos: string[] = [
    'ppu',
    'marca',
    'modelo',
    'color',
    'tipo_vehiculo',
    'anio_fabricacion',
    'ultima_transferencia',
    'numero_motor',
    'numero_chasis',
    'tasacion'
  ];
  public today: string = '';
  public rut: string = '';

  constructor(
  ) {}


  ngOnInit(): void {
    this.setDatosBasicos();
    this.setTableVehiculos();
    this.setToday();
    this.setRut();
  }

  setRut() {
    this.rut = this.content?.vehiculoReporte?.datosBasicosSolicitud?.Rut + '-' + this.content?.vehiculoReporte?.datosBasicosSolicitud?.DV
  }

  setDatosBasicos() {
    const rut = this.content?.vehiculoReporte?.datosBasicosSolicitud?.Rut + '-' + this.content?.vehiculoReporte?.datosBasicosSolicitud?.DV;

    const numeroTotal = 
      this.content?.vehiculoReporte?.vehiculos?.totalVehiculos || this.content?.vehiculoReporte?.vehiculos?.totalVehiculos == '0' ? 
        Number(this.content?.vehiculoReporte?.vehiculos?.totalVehiculos) : this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos.length;

    const valorTotal = 
      this.content?.vehiculoReporte?.vehiculos?.totalValorizacionVehiculos || this.content?.vehiculoReporte?.vehiculos?.totalValorizacionVehiculos == '0' ? 
        this.convertirAMiles(Number(this.content?.vehiculoReporte?.vehiculos?.totalValorizacionVehiculos)) : this.getSumaTasacion();

    this.datosBasicos = [
      {name: "Rut", value: rut},
      {name: "Nombre", value: this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos?.[0]?.propietario || ''},
      {name: "Número Total Vehículos", value: numeroTotal},
      {name: "Valor Total Vehículos", value: valorTotal},
    ];
  }

  convertirAMiles(monto: number): number {
    if (!monto) {
      return monto;
    }

    return monto / 1000;
  }

  getSumaTasacion() {
    if(this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos.length || this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos.length == 0) {
      const suma = this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos.reduce((a: any, b: any) => a + this.setNumber(b.tasacion), 0);
      return suma / 1000;
    }
    return '';
  }

  setTableVehiculos(): void {
    this.tableVehiculos = [];
    if(this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos && this.content?.vehiculoReporte?.vehiculos?.listadoVehiculos.length > 0) {
      
      this.content.vehiculoReporte.vehiculos.listadoVehiculos.forEach((vehiculo: any) => {
        this.tableVehiculos.push({
          ppu: vehiculo.ppu,
          marca: vehiculo.marca,
          modelo: vehiculo.modelo,
          color: vehiculo.color,
          tipo_vehiculo: vehiculo.tipo_vehiculo,
          anio_fabricacion: vehiculo.anio_fabricacion,
          ultima_transferencia: vehiculo.ultima_transferencia,
          numero_motor: vehiculo.numero_motor,
          numero_chasis: vehiculo.numero_chasis,
          tasacion: vehiculo.tasacion
        });
      });
    }
  }

  setNumber(num: string): number {
    return Number(num);
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

}
